<template>
  <div v-redirect-if-no-permission:DRIVERS :key="switch1">
    <loading-component :value="loading" />

    <DataTable :url="api.ACTIONS.CAPTAINS" :enable-edit="false" :enable-add="false" :enable-delete="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="25" :fields-hidden-main="[
        'updated_at',
        'deleted_at',
        'blacklisted_at',
        'blacklist_note',
        'account_state',
        'profile_image',
        'status',
        'full_name',
        'notification_token',
        'birthday',
        'avg_rating',
        'email',
        'nationality_id',
        'license_number'
      ]" :titles="titles" :title='$t("captainsPage.pendingDriversTitle")'  :initial-url-search-params="pendingParams" />


  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "PendingDrivers",
  //title: "Pending Drivers",
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      capStatus: "",
      timer: "",
      switch1: null,
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },


    };
  },

  computed: {
    formatters() {
      return {
        autonome_mode: (value) =>
          value
            ? this.$t("captainsPage.autonome")
            : this.$t("captainsPage.normalMode"),
        created_at(value) {
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        birthday(value) {
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        gender: (value) =>
          value == 1
            ? this.$t("captainsPage.male")
            : this.$t("captainsPage.female"),
        type: (value) =>
          value == "internal"
            ? this.$t("captainsPage.snapDriver")
            : this.$t("captainsPage.external"),
        account_code: (value) => (value === null || value === undefined || value === "" ? "-" : value),
        active(val) {
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
      };
    },
    titles() {
      return {
        created_at: this.$t("captainsPage.creationDate"),
        id: "#",
        email: this.$t("captainsPage.email"),
        active: this.$t("captainsPage.wasApproved"),
        first_name: this.$t("captainsPage.firstName"),
        last_name: this.$t("captainsPage.lastName"),
        status: this.$t("captainsPage.status"),
        username: this.$t("captainsPage.phone"),
        gender: this.$t("captainsPage.gender"),
        type: this.$t("captainsPage.type"),
        license_number: this.$t("captainsPage.licenseNumber"),
        address: this.$t("captainsPage.address"),
        nationality_id: this.$t("captainsPage.nationalityId"),
        avg_rating: this.$t("captainsPage.averageRating"),
        account_code: this.$t("captainsPage.accountCode")
      };
    },
     pendingParams() {
      const params = new URLSearchParams();
      params.append("pending", true);
      return params;
    },
    actionsExtraMain() {
      return {
        profile: {
          title: this.$t("captainsPage.captainProfile"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "CaptainProfile",
              params: { id: item.id },
            }),
        },
      };
    },

  },

  methods: {

    actionsExtra(state) {


      const goToProfile = {
        title: this.$t("captainsPage.goToProfile"),
        icon: "info",
        extras: {
          color: "secondary",
          large: true,
        },
        action: async (item) =>
          this.$router.push({
            name: "CaptainProfile",
            params: item,
          }),
      };
      return { goToProfile }
    },
  },
};
</script>

<style scoped></style>
